import React, { useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Cookies from "universal-cookie";

function CreaComentariosDirector({ idSolicitud, onComentarioCreado }) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [comentario, setComentario] = useState("");
  const [loading, setLoading] = useState(false);

  const cookies = new Cookies();
  const usuarioId = cookies.get("id");

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const postData = async (e) => {
    e.preventDefault();

    if (!comentario.trim()) {
      alert("El comentario es obligatorio");
      return;
    }

    setLoading(true);

    try {
      await axios.post(
        "https://suadesarrollo.azurewebsites.net/api/CreaComentariosFicha",
        {
          SolicitudId: idSolicitud,
          UsuarioId: usuarioId,
          Comentarios: comentario,
        },
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
        },
      );

      // 🔥 CONSULTAR NUEVAMENTE PARA TRAER EL ID REAL
      const response = await axios.get(
        `https://suadesarrollo.azurewebsites.net/api/ObtenerComentariosFicha/${idSolicitud}`,
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
        },
      );

      const lista = response.data || [];

      // 🔥 tomar el último comentario (el más reciente)
      const nuevoComentario = lista[lista.length - 1];

      if (onComentarioCreado && nuevoComentario) {
        onComentarioCreado(nuevoComentario);
      }

      setComentario("");
      closeModal();
    } catch (error) {
      console.error(error);
      alert("Error al guardar el comentario");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ marginBottom: "15px" }}>
      <button className="btn btn-primary" onClick={openModal}>
        Agregar comentario
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Comentario"
      >
        <div className="container">
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">
                Nuevo comentario
              </h6>
            </div>

            <div className="card-body">
              <form onSubmit={postData}>
                <div className="form-group">
                  <textarea
                    className="form-control"
                    placeholder="Escribe tu comentario..."
                    value={comentario}
                    onChange={(e) => setComentario(e.target.value)}
                    rows={4}
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn-success btn-block"
                  disabled={loading}
                >
                  {loading ? "Guardando..." : "Guardar"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}

export default CreaComentariosDirector;
